import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectYapiOzellikleri, updateBaslikDefaults } from '../../../../redux/baslikSlice';

export default function YapiOzellikleriSection() {
  const dispatch = useDispatch();
  const data = useSelector(selectYapiOzellikleri);

  const handleChange = (field, value) => {
    dispatch(updateBaslikDefaults({ section: 'yapiOzellikleri', changes: { [field]: value } }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-two-col">
        <div className="detail-col">
          <div className="detail-field">
            <label>Toplam Kat Sayisi</label>
            <input type="text" value={data.toplamKat} onChange={e => handleChange('toplamKat', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Yapi Sinifi</label>
            <input type="text" value={data.yapiSinifi} onChange={e => handleChange('yapiSinifi', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Yapim Suresi</label>
            <input type="text" value={data.yapimSuresi} onChange={e => handleChange('yapimSuresi', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Toplam Alan (m2)</label>
            <input type="text" value={data.toplamAlan} onChange={e => handleChange('toplamAlan', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Kullanim Amaci</label>
            <input type="text" value={data.kullanimAmaci} onChange={e => handleChange('kullanimAmaci', e.target.value)} />
          </div>
        </div>
        <div className="detail-col">
          <div className="detail-field">
            <label>Eski Toplam Guc (W)</label>
            <input type="text" value={data.eskiGuc} onChange={e => handleChange('eskiGuc', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Eklenen Guc (W)</label>
            <input type="text" value={data.eklenenGuc} onChange={e => handleChange('eklenenGuc', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Top. Kurulu Guc (W)</label>
            <input type="text" value={data.topKuruluGuc} onChange={e => handleChange('topKuruluGuc', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Bagimsiz Bol. Sayisi</label>
            <input type="text" value={data.bagimsizBolSayisi} onChange={e => handleChange('bagimsizBolSayisi', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Talep Fak. (%)</label>
            <input type="text" value={data.talepFaktoru} onChange={e => handleChange('talepFaktoru', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Talep Guc (W)</label>
            <input type="text" value={data.talepGuc} onChange={e => handleChange('talepGuc', e.target.value)} />
          </div>
        </div>
      </div>

      <div className="detail-col-title" style={{ marginTop: 8 }}>Cizim Bilgileri</div>
      <div className="detail-two-col">
        <div className="detail-col">
          <div className="detail-field">
            <label>Cizen</label>
            <input type="text" value={data.cizen} onChange={e => handleChange('cizen', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Cizim Tarihi</label>
            <input type="text" value={data.cizimTarihi} onChange={e => handleChange('cizimTarihi', e.target.value)} />
          </div>
        </div>
        <div className="detail-col">
          <div className="detail-field">
            <label>Olcek</label>
            <input type="text" value={data.olcek} onChange={e => handleChange('olcek', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Proje No</label>
            <input type="text" value={data.projeNo} onChange={e => handleChange('projeNo', e.target.value)} />
          </div>
        </div>
      </div>
    </div>
  );
}
